/**
 * Pendo integration contracts (target elements + ignore markers).
 *
 * ⚠️ DO NOT change exported `id`s, legacy class tokens, button `size`, visible
 * labels, or the `pendo-ignore` class string without coordinating a Pendo
 * guide / Resource Center update. Agents and guides match these attributes
 * (and historically relied on the gray-* light-mode chrome classes).
 *
 * @see SessionTenantContext (pendo.initialize)
 * @see index.css (.pendo-ignore marker)
 */

/** Class that excludes an element from Pendo tracking / guide latching. */
export const PENDO_IGNORE_CLASS = "pendo-ignore";

/**
 * Shared light-mode chrome classes Pendo target matching historically used.
 * Dark overrides are app theme only — keep the gray-* tokens in the string.
 */
export const PENDO_SIDEBAR_ACTION_CLASSNAME =
  "w-full justify-start font-light text-sm border-gray-300 text-gray-700 hover:bg-gray-100 hover:text-gray-900 transition-colors dark:border-border dark:bg-card dark:text-muted-foreground dark:hover:bg-muted dark:hover:text-foreground";

/**
 * Sidebar “Submit Feedback” — Pendo Resource Center / guide target.
 * @type {{ id: string, size: 'lg', label: string, className: string }}
 */
export const PENDO_SUBMIT_FEEDBACK = {
  id: "pendo-submit-feedback",
  size: "lg",
  label: "Submit Feedback",
  className: PENDO_SIDEBAR_ACTION_CLASSNAME,
};

/**
 * Sidebar “Contact Support” — Pendo Resource Center / guide target.
 * @type {{ id: string, size: 'lg', label: string, className: string }}
 */
export const PENDO_CONTACT_SUPPORT = {
  id: "pendo-contact-support",
  size: "lg",
  label: "Contact Support",
  className: PENDO_SIDEBAR_ACTION_CLASSNAME,
};
